
export enum OnboardingWizardStepNames {
    FIRST_IMPORT = 'FIRST_IMPORT',
    FIRST_EXPORT = 'FIRST_EXPORT',
    SECOND_IMPORT = 'SECOND_IMPORT',
    PII_SERVICE = 'PII_SERVICE',
    IDENTITY_PROVIDER = 'IDENTITY_PROVIDER',
    MERGING_RULES = 'MERGING_RULES',
    MFA = 'MFA',
    SECOND_EXPORT = 'SECOND_EXPORT'
}

export const PII_SERVICE_ACTIVATED = 'PII_SERVICE_ACTIVATED';

export class OnboardingWizardStep {
    constructor(
        public step: OnboardingWizardStepNames,
        public title: string,
        public description: string,
        public actionButton: string,
        public matIcon: string,
        public completed: boolean = false,
        public disabled: boolean = false
    ) {
    }
}

export const ProviderOnboardingWizard = [
    new OnboardingWizardStep(
        OnboardingWizardStepNames.FIRST_IMPORT,
        'Successful first data import',
        'Connect your first data source to SchoolDay to roster students, teachers, staff and contacts.',
        'Choose & Activate SIS',
        'cloud_upload'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.FIRST_EXPORT,
        'Successful first data export',
        'Connect and activate your first export application.',
        'Choose & Activate',
        'cloud_download'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.PII_SERVICE,
        'Discover & manage all EdTech applications',
        'Help detect and protect risks to your PII by using Privacy Governance Console (PGC) within your district.',
        'Activate & Detect PII Risks',
        'shield'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.SECOND_IMPORT,
        'Import data from additional data source',
        'Link additional data sources to be able to control, merge, protect and safety export your data.',
        'Choose & Activate data source',
        'cloud_upload'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.IDENTITY_PROVIDER,
        'Add Identity Provider (IdP)',
        'Add and import your Identity Provider information to SchoolDay.',
        'Add IdP',
        'badge'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.MERGING_RULES,
        'View merging rules',
        'View simple and/or complex merging rules to improve your data connections.',
        'Create merging rule',
        'merge'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.MFA,
        'Enable MFA for any & all age of user',
        'Enable 2FA to secure your login process for all users from 1st grade up to adults.',
        'Enable MFA',
        'lock'
    ),
    new OnboardingWizardStep(
        OnboardingWizardStepNames.SECOND_EXPORT,
        'Increase value by adding a second export application',
        'Set up data export processes to safety and securely give vendors access to your data.',
        'Choose & Activate Export',
        'cloud_download'
    ),
];
